module.exports = __webpack_public_path__ + "static/img/outsourcing.7964bf5.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/assets/images/services/outsourcing.jpg
// module id = tW+w
// module chunks = 1